import { IModel, Model, ModelRecord } from '@common/models/Model';
import { observable } from 'mobx';

export interface IPetPreviousVisitModel extends IModel {
  visitId: number;
  petId: number;
  visitStatusId: number;
  visitDate: string;
  appointmentTypeName: string;
  appointmentTypeColor: string | undefined;
}

export class PetPreviousVisitModel
  extends Model
  implements ModelRecord<IPetPreviousVisitModel>
{
  @observable visitId: number;
  petId: number;
  visitStatusId: number;
  visitDate: string;
  appointmentTypeName: string;
  appointmentTypeColor: string | undefined;

  constructor(params: Partial<IPetPreviousVisitModel>) {
    super(params);
    this.visitId = _.defaultTo(params.visitId, 0);
    this.petId = _.defaultTo(params.petId, 0);
    this.visitDate = _.defaultTo(params.visitDate, '');
    this.appointmentTypeColor = _.defaultTo(params.appointmentTypeColor, '');
    this.appointmentTypeName = _.defaultTo(params.appointmentTypeName, '');
    this.visitStatusId = params.visitStatusId ?? 0;
  }
}
